

export const CHANNEL_MAPPING = Object.freeze({
  EDITABLE_FIELDS: ['hcpMerchantChannel','hcpChannelType', 'excluded', 'ignored'],
});



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_constants.jsx